<template>
    <div class="footer">
        <div class="row">
            <div class="col-12 col-md-2 contact">
                <h6>
                    <div class="contact-address">
                        <div>OMyFu</div>
                        <div>8051 {{$t('footer.contact.city')}}</div>
                        <div>{{$t('footer.contact.country')}}</div>
                        <div class="mail-to">
                            <a href="mailto:info@omyfu.com" target="_top">info@omyfu.com</a>
                        </div>
                    </div>
                </h6>
            </div>
            <div class="col-12 col-md-10">
                <h6>
                    <div class="social-media-icons row">
                        <div class="col-lg-3 hidden-lg"></div>
                        <div class="col-12 col-sm-auto icon-group-container">
                            <span class="social-media-single-icon">
                                <a href="https://itunes.apple.com/us/app/omyfu/id1423062463?ls=1&mt=8" target="_blank"><img src="../assets/images/icons/app_store_badge_mustard.png" height="40px"></a>
                            </span>
                            <span class="social-media-single-icon">
                                <a href="https://play.google.com/store/apps/details?id=com.omyfu.androidApp&hl=de" target="_blank"><img src="../assets/images/icons/google_play_badge_mustard.png" height="40px"></a>
                            </span>
                        </div>
                        <div class="col-12 col-sm-auto icon-group-container">
                            <span class="social-media-single-icon">
                                <social-sharing url="http://www.omyfu.com/"
                                                :quote="$t('footer.socialSharing.facebook')"
                                                inline-template>
                                        <network network="facebook" id="fb-icon">
                                            <img src="../assets/images/icons/fb_icon.png" height="36px"/>
                                        </network>
                                </social-sharing>
                            </span>
                            <span class="social-media-single-icon">
                                <a :href="$t('footer.socialSharing.twitter')" target="_blank">
                                    <img src="../assets/images/icons/twitter_icon.png" width="36px"/>
                                </a>
                            </span>
                            <span class="social-media-single-icon">
                                <a :href="$t('footer.socialSharing.whatsapp')" target="_blank">
                                    <img src="../assets/images/icons/whatsapp_icon.png" width="36px"/>
                                </a>
                            </span>
                            <span class="social-media-single-icon">
                                <a :href="$t('footer.socialSharing.sms')" target="_blank">
                                    <img src="../assets/images/icons/sms_icon.png" width="36px"/>
                                </a>
                            </span>
                            <span class="social-media-single-icon">
                                <a :href="$t('footer.socialSharing.email')" target="_blank">
                                    <img src="../assets/images/icons/email_icon.png" width="36px"/>
                                </a>
                            </span>
                        </div>
                    </div>
                    <div class="legal">
                        <div class="row">
                            <div class="col-12">
                                <h6>
                                    <a href="https://www.omyfu.com/imprint" target="_blank">{{$t('footer.imprint')}}</a>
                                    |
                                    <a href="https://omyfu.com/disclaimer" target="_blank">{{$t('footer.disclaimer')}}</a>
                                    Copyright © 2019 OMyFu | {{version}}
                                </h6>
                            </div>
                            <!--<div class="col-12 col-md-6">-->
                                <!--<h6>-->
                                    <!--<span class="language-selection">-->
                                        <!--<a href="javascript:void(0)" v-on:click="switchLang('de')">Deutsch</a>-->
                                        <!--<a href="javascript:void(0)" v-on:click="switchLang('en')">English</a>-->
                                    <!--</span>-->
                                <!--</h6>-->
                            <!--</div>-->
                        </div>
                    </div>
                </h6>
            </div>
        </div>
    </div>
</template>

<script>
    import router from '../router/index'
    import siteconfig from '../assets/data/siteconfig'
    export default {
        name: 'Footer',
        computed: {
            version: function () {
                return siteconfig.version
            }
        },
        methods: {
            switchLang: function (lang) {
                this.$i18n.locale = lang
            },
            goToDisclaimer: function () {
                router.push('disclaimer')
            },
            goToImprint: function () {
                router.push('imprint')
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../assets/scss/custom/vars';

    .footer {
        background-color: black;
        color: white;
        padding-left: 48px;
        padding-right: 48px;
        padding-bottom: 36px;
        padding-top: 36px;
    }

    .contact {
        text-align: left;
        padding-top: 54px;
    }

    .icon-group-container {
        margin-left:auto;
        margin-right:0;
    }
    .contact-address {
        line-height: 1.65;
    }

    .social-media-icons {
        padding-top: 36px;
    }

    .social-media-single-icon {
        padding-left: 8px;
    }

    .legal {
        text-align: right;
        padding-top: 42px;
    }

    .legal a {
        color: white;
    }

    .mail-to a {
        color: white;
    }

    @media (max-width: 767px) {
        .social-media-icons {
            text-align: center;
        }
        .legal {
            text-align: center;
            padding-top: 20px;
        }
        .icon-group-container {
            margin-left:auto;
            margin-right:auto;
            padding-top: 20px;
            padding-bottom: 10px;
        }
        .contact {
            text-align: center;
            padding-top: 4px;
        }
    }

    @media (max-width: 575.98px) {
        .contact {
            text-align: center;
        }
        .social-media-icons {
            text-align: center;
        }
        .legal {
            text-align: center;
            padding-top: 20px;
        }
    }

    @media (max-width: 330.98px) {
        .social-media-single-icon {
            padding-left: 2px;
        }
    }

    .language-selection {
        padding-top: 24px;
        padding-left: 6px;
    }

    .language-selection a {
        color: $omyfu-yellow;
        font-weight: bold;
        padding-left: 4px;
    }

    #fb-icon {
        cursor: pointer;
    }

    @media print {
        .footer {
            visibility: hidden;
            display: none;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/FooterComponent.vue